(() => {
  const COLOR_RE = /^\s*Colore:\s*(.+?)\s+[—-]\s+/i;

  const aliases = {
    'vede': 'verde',
    'blue': 'blu',
    'grey': 'grigio',
    'gray': 'grigio',
    'black': 'nero',
    'white': 'bianco',
    'red': 'rosso',
    'navy': 'blu navy'
  };

  const normalize = (value) => {
    if (!value) return '';
    let v = String(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[_/]+/g, ' ')
      .replace(/\s+/g, ' ');
    return aliases[v] || v;
  };

  const taggedColor = (element) => {
    if (!element) return '';
    const images = element.matches('img[alt]') ? [element] : element.querySelectorAll('img[alt]');
    for (const img of images) {
      const match = (img.getAttribute('alt') || '').match(COLOR_RE);
      if (match) return normalize(match[1]);
    }
    return '';
  };

  const selectedColor = (section) => {
    const fieldsets = section.querySelectorAll('fieldset.product-form__input');
    for (const fieldset of fieldsets) {
      const label = normalize(fieldset.querySelector('.form__label')?.textContent || '');
      if (label.includes('color') || label.includes('colore') || label.includes('colour')) {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) return normalize(checked.value);
      }
    }

    const wrappers = section.querySelectorAll('.product-form__input');
    for (const wrapper of wrappers) {
      const label = normalize(wrapper.querySelector('.form__label')?.textContent || '');
      if (label.includes('color') || label.includes('colore') || label.includes('colour')) {
        const select = wrapper.querySelector('select');
        if (select) return normalize(select.value);
      }
    }

    const checkedRadios = [...section.querySelectorAll('fieldset.product-form__input input[type="radio"]:checked')];
    const nonSize = checkedRadios.find((input) => {
      const name = normalize(input.name || '');
      return !name.includes('size') && !name.includes('taglia');
    });
    return normalize(nonSize?.value || '');
  };

  const clearState = (el) => {
    if (!el) return;
    el.classList.remove('moro-gallery-color-hidden', 'moro-gallery-color-visible');
    el.removeAttribute('aria-hidden');
  };

  const setVisible = (el, visible) => {
    if (!el) return;
    el.classList.toggle('moro-gallery-color-hidden', !visible);
    el.classList.toggle('moro-gallery-color-visible', visible);
    el.setAttribute('aria-hidden', visible ? 'false' : 'true');
  };

  const ensureMessage = (gallery) => {
    let message = gallery.querySelector('.moro-gallery-missing-color');
    if (!message) {
      message = document.createElement('div');
      message.className = 'moro-gallery-missing-color';
      message.setAttribute('role', 'status');
      message.textContent = 'Immagine specifica di questo colore non disponibile.';
      const viewer = gallery.querySelector('slider-component');
      if (viewer) viewer.insertAdjacentElement('afterend', message);
      else gallery.appendChild(message);
    }
    return message;
  };

  const apply = (section) => {
    const gallery = section.querySelector('media-gallery');
    if (!gallery) return;

    const color = selectedColor(section);
    const slides = [...gallery.querySelectorAll('.product__media-item')];
    const thumbs = [...gallery.querySelectorAll('.thumbnail-list__item')];
    const taggedSlides = slides.filter((slide) => taggedColor(slide));
    const modal = document.getElementById(section.id.replace('MainProduct-', 'ProductModal-'));
    const modalItems = modal ? [...modal.querySelectorAll('.product-media-modal__content > [data-media-id]')] : [];

    if (!color || taggedSlides.length === 0) {
      slides.forEach(clearState);
      thumbs.forEach(clearState);
      modalItems.forEach(clearState);
      const old = gallery.querySelector('.moro-gallery-missing-color');
      if (old) old.hidden = true;
      return;
    }

    const hasMatchingColour = taggedSlides.some((slide) => taggedColor(slide) === color);

    slides.forEach((slide) => {
      const mediaColor = taggedColor(slide);
      if (!mediaColor) {
        clearState(slide);
      } else {
        setVisible(slide, hasMatchingColour && mediaColor === color);
      }
    });

    thumbs.forEach((thumb) => {
      const mediaColor = taggedColor(thumb);
      if (!mediaColor) {
        clearState(thumb);
      } else {
        setVisible(thumb, hasMatchingColour && mediaColor === color);
      }
    });

    modalItems.forEach((item) => {
      const mediaColor = taggedColor(item);
      if (!mediaColor) clearState(item);
      else setVisible(item, hasMatchingColour && mediaColor === color);
    });

    gallery.querySelectorAll('slider-component').forEach((slider) => {
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });

    const visibleSlides = slides.filter((slide) => {
      if (slide.classList.contains('moro-gallery-color-hidden')) return false;
      return window.getComputedStyle(slide).display !== 'none';
    });

    const message = ensureMessage(gallery);
    message.hidden = visibleSlides.length > 0;

    const total = gallery.querySelector('.slider-counter--total');
    if (total && visibleSlides.length) total.textContent = String(visibleSlides.length);

    const currentActive = visibleSlides.find((slide) => slide.classList.contains('is-active'));
    if (!currentActive && visibleSlides[0]) {
      const mediaId = visibleSlides[0].dataset.mediaId;
      const targetThumb = mediaId && gallery.querySelector('[data-target="' + CSS.escape(mediaId) + '"] button');
      if (targetThumb) targetThumb.click();
    }
  };

  const applyAll = () => {
    document.querySelectorAll('section[id^="MainProduct-"]').forEach(apply);
  };

  document.addEventListener('DOMContentLoaded', applyAll);
  document.addEventListener('change', (event) => {
    const section = event.target.closest?.('section[id^="MainProduct-"]');
    if (!section) return;
    window.setTimeout(() => apply(section), 60);
    window.setTimeout(() => apply(section), 220);
  });

  document.addEventListener('shopify:section:load', applyAll);
  window.setTimeout(applyAll, 250);
})();